const actionTypes = {
  TOGGLE_SETTLE_DRAWER_VISIBLE: Symbol('TOGGLE_SETTLE_DRAWER_VISIBLE'),

  SET_ORDER_STATE_LOADING: Symbol('SET_ORDER_STATE_LOADING'),
  INIT_ORDER_STATE: Symbol('INIT_ORDER_STATE'),
  SET_ORDER_STATE: Symbol('SET_ORDER_STATE'),

  SET_SETTLE_STEP: Symbol('SET_SETTLE_STEP'),

  SET_ORDER_INFO_LOADING: Symbol('SET_ORDER_INFO_LOADING'),
  FETCH_ORDER_INFO: Symbol('FETCH_ORDER_INFO'),
  UPDATE_ORDER_INFO: Symbol('UPDATE_ORDER_INFO'),
  RESET_ORDER_INFO: Symbol('RESET_ORDER_INFO'),

  SET_CHECK_ROOM_LIST_LOADING: Symbol('SET_CHECK_ROOM_LIST_LOADING'),
  FETCH_CHECK_ROOM_LIST: Symbol('FETCH_CHECK_ROOM_LIST'),

  SET_SETTLE_INFO_LOADING: Symbol('SET_SETTLE_INFO_LOADING'),
  FETCH_SETTLE_INFO: Symbol('FETCH_SETTLE_INFO'),

  TOGGLE_OVERSTAY_MODAL_VISIBLE: Symbol('TOGGLE_OVERSTAY_MODAL_VISIBLE'),
  SET_OVERSTAY_LIST_LOADING: Symbol('SET_OVERSTAY_LIST_LOADING'),
  INIT_OVERSTAY_LIST: Symbol('INIT_OVERSTAY_LIST'),
  UPDATE_OVERSTAY_LIST: Symbol('UPDATE_OVERSTAY_LIST'),
};

export default actionTypes;
